export default __webpack_public_path__ + "static/media/anniversary_Cn.7c56406d.jpg";